module.exports = __webpack_public_path__ + "img/preview-mob.34c45c0a.svg";